

















































































































import Vue from 'vue';
import Component from 'vue-class-component';
import PopInCGU from './PopInCGU.vue';
import PopInMentionsLegales from './PopInMentionsLegales.vue';
import PopInDifficultes from './PopInDifficultes.vue';
import { mdiPhone, mdiChevronUp } from '@mdi/js';
import _ from 'lodash';

import pkg from '../../../../package.json';

/** The application footer */
@Component({
	components: {
		PopInCGU,
		PopInMentionsLegales,
		PopInDifficultes
	}
})
export default class Footer extends Vue {
	phone = mdiPhone;
	haut = mdiChevronUp;
	/** The version from package.json */
	version = pkg.version;

	get redirectToConfig(): string {
		const cookieUrl = _.split(this.$cookies.get('ep-origin'), '//');
		const protocole = cookieUrl[0];

		let url = '';
		if (_.size(cookieUrl) > 1 && !_.isEmpty(cookieUrl[1])) {
			const domain = _.split(cookieUrl[1], '/')[0];
			url += protocole + '//' + domain + '/inscription/#/aide?scroll=configuration';
		}

		return url;
	}

	scrollToTop(): void {
		window.scrollTo(0, 0);
	}

}
